import moment from "moment";

export const getBackgroundColor = (type) => {
  switch (type) {
    case "customer":
      return "bg-[#E5FFF0]";
    case "collaborator":
      return "bg-[#FFF2E3]";
    default:
      return "bg-[#EDF5FF]";
  }
};

export const getTypeTextColor = (type) => {
  switch (type) {
    case "customer":
      return "text-[#27AE60]";
    case "collaborator":
      return "text-[#F7921E]";
    default:
      return "text-[#2F80ED]";
  }
};

export const getInitials = (name) => {
  const words = name?.split(" ") || [];
  let initials = "";
  for (let word of words) {
    initials += word.charAt(0).toUpperCase() !== "-" ? word.charAt(0).toUpperCase() : "";
    if (initials.length === 2) break;
  }
  return initials;
};

export const getBGforMenuAvatar = (text = "") => {
  if (text.toLowerCase().includes("customer")) {
    return "bg-[#27AE60]";
  } else if (text.toLowerCase().includes("collaborator")) {
    return "bg-[#F7921E]";
  } else {
    return "bg-[#2F80ED]";
  }
};

export const isGroupActive = (group, activeGroup) => {
  return group && activeGroup && group.sub_group_id === activeGroup.sub_group_id ? true : false;
};

export const getTimeForMessage = (dateTime) => {
  if(dateTime === null){
    return "";
  }
  const currentDateTime = moment();
  const provideDateTime = moment(dateTime);
  const differenceDateTime = currentDateTime.diff(provideDateTime, 'days');
  
  return differenceDateTime >= 1 ? moment(dateTime).format("DD/MMM/yy") : moment(dateTime).format("hh:mm a")

}

export const getMessageContent = (data) => {
  let item = {};
  if (!data.includes("path")) {
    item = {
      path: data,
      type: "docs",
    };
  } else {
    item = JSON.parse(data);
  }

  return (
    <div className="bg-white rounded-sm p-2 relative">
      {item.type === "image" && (
        <div className="w-40 h-full">
          {item?.path && item.path.includes("amazonaws.com/") ? (
            <img src={item?.path} alt="" />
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-40 h-40 text-gray-500"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
              />
            </svg>
          )}
        </div>
      )}
      {item.type === "video" && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="w-40 h-40 text-gray-500"
        >
          <path
            strokeLinecap="round"
            d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z"
          />
        </svg>
      )}
      {item.type === "docs" && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="w-40 h-40 text-gray-500"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"
          />
        </svg>
      )}
      {item?.path && item.path.includes("amazonaws.com/") && (
        <div className="absolute bottom-1 right-1 flex justify-end mt-1 bg-white rounded-full">
          <a href={item.path} target="_blank" rel="noreferrer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-6 h-6 rounded-md p-1 text-gray-500 bg-slate-100 hover:text-gray-600 hover:bg-slate-200 hover:duration-200 hover:scale-110 hover:ease-in-out"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
              />
            </svg>
          </a>
        </div>
      )}
    </div>
  );
};
